<template>
    <wc-dialog :showDialog='show' :title='title' :hideSave='true' cancelText="close" @cancel='close'>
        <v-simple-table dense>
        <thead v-if='line_items.length > 0'>
            <tr>
                <th text-align='left'>Date</th>
                <th text-align='left'>Invoice</th> 
                <th text-align='left'>Description</th>
                <th text-align='right'>Subtotal</th>
            </tr>
        </thead>
        <thead v-else>
            <tr>
                <th class='grey--text' color='primary' text-align="center" style='padding: 15px; text-align: center'>
                    <v-progress-circular indeterminate style="width: 100%"></v-progress-circular>
                </th>
            </tr>
        </thead>
        <tbody v-if='line_items.length > 0'>
            <tr v-for='line_item in line_items' :key='line_item.id'>
                <td>{{ line_item.line_item_date | shortDate }}</td>
                <td>
                    <a @click='openInvoice(line_item.invoice)'>{{ line_item.invoice_data.number }}</a></td>
                <td>
                    {{ line_item.description }}
                </td>
                <td >
                    {{subtotal(line_item) | decMoney}}
                </td>
            </tr>
            <tr>
            <td style='border-top: solid 1px black'></td>
            <td style='border-top: solid 1px black'></td>
            <td class='font-weight-bold' style='border-top: solid 1px black'>TOTALS</td>
            <td class='font-weight-bold' :width='amountWidth' style='border-top: solid 1px black'>{{total | decMoney}}</td>
            </tr>
        </tbody>
        <tbody v-else>

        </tbody>
        </v-simple-table>
    </wc-dialog>
</template>

<script>
import miscServices from '@/services/misc';

export default {
  name: 'invoice-line-item-table',
  data: () => ({
    amountWidth: 120
  }),
  props: {
    line_items: {
        type: Array,
        default(){
            return [];
        }
    },
    show: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    total: {
        type: Number,
        default: 0
    }
  },
  computed: {
  },
  methods: {
    subtotal (line_item) {
        return line_item.qty * line_item.price;
    },
    openInvoice (id) {
      miscServices.openInNewTab({ name: 'InvoiceOverview', params: { id: id } });
    },
    escapePressed () {
      this.$emit('close');
    },
    close(){
      this.$emit('close');
    }
  }
}
</script>

